module.exports = __webpack_public_path__ + "static/Forager11-eadc5c5ab6aefdcad18876e3eca862f6.webp";